var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesDesktop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1617 1.38965H4.81999C2.79494 1.38965 1.15332 3.03128 1.15332 5.05632V23.9764C1.15332 26.0014 2.79494 27.643 4.81999 27.643H35.1617C37.1867 27.643 38.8283 26.0014 38.8283 23.9764V5.05632C38.8283 3.03128 37.1867 1.38965 35.1617 1.38965Z",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7383 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75342 34.6099H32.2468",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.867 7.7334H7.80029C7.24801 7.7334 6.80029 8.18111 6.80029 8.7334V14.8001C6.80029 15.3524 7.24801 15.8001 7.80029 15.8001H13.867C14.4192 15.8001 14.867 15.3524 14.867 14.8001V8.7334C14.867 8.18111 14.4192 7.7334 13.867 7.7334Z",
    fill: "#AFD0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 7.7334H17.3335C16.7812 7.7334 16.3335 8.18111 16.3335 8.7334V14.8001C16.3335 15.3524 16.7812 15.8001 17.3335 15.8001H32.2002C32.7525 15.8001 33.2002 15.3524 33.2002 14.8001V8.7334C33.2002 8.18111 32.7525 7.7334 32.2002 7.7334Z",
    fill: "#AFD0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2003 16.5332H7.80029C7.24801 16.5332 6.80029 16.9809 6.80029 17.5332V19.9332C6.80029 20.4855 7.24801 20.9332 7.80029 20.9332H32.2003C32.7526 20.9332 33.2003 20.4855 33.2003 19.9332V17.5332C33.2003 16.9809 32.7526 16.5332 32.2003 16.5332Z",
    fill: "#AFD0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 14.9999C28.4394 14.9999 29.201 14.2324 29.201 13.2856C29.201 12.3388 28.4394 11.5713 27.4999 11.5713C26.5604 11.5713 25.7988 12.3388 25.7988 13.2856C25.7988 14.2324 26.5604 14.9999 27.4999 14.9999Z",
    fill: "#0D6EFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4998 8.71436C26.0379 8.71436 24.6572 9.43096 23.8064 10.6313C23.5637 10.9737 23.6424 11.4496 23.9821 11.6942C24.1153 11.7901 24.2689 11.8362 24.421 11.8362C24.6569 11.8362 24.8893 11.7252 25.0368 11.5171C25.6044 10.7163 26.5251 10.2382 27.4997 10.2382C28.4744 10.2382 29.3951 10.7163 29.9626 11.517C30.2053 11.8594 30.6775 11.9388 31.0173 11.6942C31.3571 11.4496 31.4358 10.9737 31.1931 10.6313C30.3424 9.43092 28.9617 8.71436 27.4998 8.71436Z",
    fill: "#0D6EFD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5.85693C25.4117 5.85693 23.4129 6.75549 22.0159 8.3222C21.7369 8.6352 21.7624 9.11693 22.073 9.39821C22.2174 9.52901 22.3981 9.59342 22.5781 9.59342C22.7852 9.59338 22.9914 9.50819 23.1407 9.34074C24.2513 8.09517 25.8402 7.3808 27.5 7.3808C29.1598 7.3808 30.7488 8.09517 31.8594 9.3407C32.1385 9.6537 32.6165 9.6794 32.9271 9.39817C33.2377 9.11689 33.2632 8.63516 32.9841 8.3222C31.587 6.75545 29.5882 5.85693 27.5 5.85693Z",
    fill: "#0D6EFD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7835 6.08115C32.8481 4.09423 30.2615 3 27.5 3C24.7386 3 22.152 4.09423 20.2165 6.08123C19.924 6.38155 19.9284 6.8639 20.2264 7.15868C20.3736 7.30428 20.5648 7.37691 20.756 7.37687C20.9518 7.37687 21.1475 7.30064 21.2955 7.14873C22.9444 5.45601 25.1478 4.52382 27.5 4.52382C29.8523 4.52382 32.0557 5.45601 33.7044 7.14865C33.997 7.44896 34.4756 7.45338 34.7736 7.15864C35.0716 6.86386 35.076 6.38147 34.7835 6.08115Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesDesktop2);
export default __webpack_public_path__ + "static/media/devices-desktop-2.da61e308eaf392d6ad5372e4e1485978.svg";
export { ForwardRef as ReactComponent };